module.exports = __webpack_public_path__ + "w.no2.5c5526d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/w.no2.jpg
// module id = 1APp
// module chunks = 0